/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type TypeOfProblemV2ConfigColumn =
  (typeof TypeOfProblemV2ConfigColumn)[keyof typeof TypeOfProblemV2ConfigColumn];

export const TypeOfProblemV2ConfigColumn = {
  type_of_problem_v2: 'type_of_problem_v2',
} as const;
